import React from 'react'
import classes from './NavBar.module.css'
const NavBar = (props)=>{
    const id = props.id
    console.log(id)
    let border = null
    if(props.active){
        border = {"border-bottom":"4px solid #00aeef","margin-bottom":"0px","background-color":"transparent","font-weight":"bold"}
    }
    return(
        <button  style = {border} className={classes.container} onClick={props.onclick}>
            <p className={classes.name}> {props.children}</p>
        </button>
    )
}
export default NavBar